var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"parent":"tools"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.$t("promocodes_table.title"))+"\n    ")]},proxy:true},{key:"actions",fn:function(){return [_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":("/api/promocodes/groups/export/" + (_vm.group._id))}},[_c('BaseButton',{attrs:{"variant":"secondary","size":"md","color":"v1-grey-10"}},[_vm._v("\n          "+_vm._s(_vm.$t("promocodes_table.export_btn"))+"\n        ")])],1)]},proxy:true}])}),(_vm.group)?_c('IQOSTable',{attrs:{"rows":_vm.group.promocodes,"cols":[
      {
        title: '#',
        index: true,
        width: 80,
      },
      {
        title: _vm.$t('promocodes_table.col_code'),
        key: 'code',
      },
      {
        title: _vm.$t('promocodes_table.col_name'),
        key: 'client_name',
        default: '',
      },
      {
        title: _vm.$t('promocodes_table.col_phone'),
        key: 'client_phone',
        default: '',
      },
      {
        title: _vm.$t('promocodes_table.col_date'),
        key: 'used_at',
      },
      {
        title: _vm.$t('promocodes_table.col_status'),
        key: 'status',
      } ]},scopedSlots:_vm._u([{key:"col-status",fn:function(slotProps){return [(slotProps.rowItem.used_at)?_c('span',{staticClass:"red-4-color"},[_vm._v("\n        "+_vm._s(_vm.$t("promocodes_table.status_used"))+"\n      ")]):_c('span',{staticClass:"green-5-color"},[_vm._v("\n        "+_vm._s(_vm.$t("promocodes_table.status_not_used"))+"\n      ")])]}},{key:"col-used_at",fn:function(slotProps){return [(slotProps.rowItem.used_at)?_c('span',[_vm._v("\n        "+_vm._s(_vm._f("formatDatetime")(slotProps.rowItem.used_at))+"\n      ")]):_vm._e()]}}],null,false,23314229)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }